var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCake(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.2 13.874V26.374H2V13.874H9V20.574C9 21.131 9.22125 21.6651 9.61507 22.059C10.0089 22.4528 10.543 22.674 11.1 22.674H11.2C11.4841 22.6876 11.7679 22.6433 12.0344 22.5438C12.3008 22.4444 12.5443 22.2918 12.75 22.0955C12.9557 21.8991 13.1194 21.663 13.2311 21.4015C13.3429 21.1399 13.4003 20.8584 13.4 20.574V13.874H30.2Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2 13.8741L15.8 7.07408C13.7985 6.05706 11.5108 5.75052 9.31213 6.20478C7.1135 6.65905 5.13456 7.84713 3.7 9.57408C2.69461 10.7926 2.09966 12.2975 2 13.8741",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2 20.1738H4.9",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2998 20.1738H30.1998",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCake);
export default __webpack_public_path__ + "static/media/cake.6da49e986df813305af7e39c3fbc7dec.svg";
export { ForwardRef as ReactComponent };